// ─── APP-WIDE CONSTANTS ───────────────────────────────────────────────────────

export const TIMELINE_CATEGORIES = [
  { value: 'project-management',     label: 'Project Management',         emoji: '📋' },
  { value: 'personal-biography',     label: 'Personal Biography',         emoji: '👤' },
  { value: 'company-history',        label: 'Company History',            emoji: '🏢' },
  { value: 'product-roadmap',        label: 'Product Roadmap',            emoji: '🗺️' },
  { value: 'historical-events',      label: 'Historical Events',          emoji: '📜' },
  { value: 'medical-history',        label: 'Medical History',            emoji: '🏥' },
  { value: 'legal-case',             label: 'Legal Case Timeline',        emoji: '⚖️' },
  { value: 'marketing-campaign',     label: 'Marketing Campaign',         emoji: '📣' },
  { value: 'education',              label: 'Education / Curriculum',     emoji: '🎓' },
  { value: 'sports',                 label: 'Sports Season / Career',     emoji: '🏆' },
  { value: 'construction',           label: 'Construction / Real Estate', emoji: '🏗️' },
  { value: 'event-planning',         label: 'Wedding / Event Planning',   emoji: '💐' },
  { value: 'software-development',   label: 'Software Development',       emoji: '💻' },
  { value: 'startup-journey',        label: 'Startup Journey',            emoji: '🚀' },
  { value: 'investigative-research', label: 'Investigative Research',     emoji: '🔍' },
  { value: 'onboarding',             label: 'Onboarding Process',         emoji: '🤝' },
  { value: 'scientific-research',    label: 'Scientific Research',        emoji: '🔬' },
  { value: 'political-campaign',     label: 'Political Campaign',         emoji: '🗳️' },
  { value: 'family-genealogy',       label: 'Family Genealogy',           emoji: '🌳' },
  { value: 'crisis-management',      label: 'Crisis / Incident Mgmt',    emoji: '🚨' },
  { value: 'travel-trip',            label: 'Travel / Trip',              emoji: '✈️' },
  { value: 'road-trip',              label: 'Road Trip',                  emoji: '🚗' },
  { value: 'expedition',             label: 'Expedition / Adventure',     emoji: '🧭' },
  { value: 'immigration-journey',    label: 'Immigration Journey',        emoji: '🛳️' },
  { value: 'military-campaign',      label: 'Military Campaign',          emoji: '🎖️' },
  { value: 'archaeological-dig',     label: 'Archaeological Dig',         emoji: '⛏️' },
  { value: 'wildlife-migration',     label: 'Wildlife Migration',         emoji: '🦅' },
  { value: 'natural-disaster',       label: 'Natural Disaster',           emoji: '🌋' },
  { value: 'academic-year',          label: 'Academic Year',              emoji: '📚' },
  { value: 'fiscal-year',            label: 'Fiscal Year / Budget Cycle', emoji: '💰' },
  { value: 'training-season',        label: 'Training / Fitness Journey', emoji: '🏋️' },
  { value: 'music-tour',             label: 'Music Album / Tour',         emoji: '🎵' },
  { value: 'tv-season',              label: 'TV Season / Series',         emoji: '🎬' },
  { value: 'agricultural-cycle',     label: 'Agricultural / Harvest',     emoji: '🌾' },
  { value: 'religious-calendar',     label: 'Religious / Liturgical Year',emoji: '🕍' },
  { value: 'annual-traditions',      label: 'Annual Traditions / Holidays',emoji: '🎉' },
  { value: 'release-calendar',       label: 'Product Release Calendar',   emoji: '📅' },
  { value: 'award-season',           label: 'Award Season',               emoji: '🏅' },
  { value: 'book-writing',           label: 'Book / Writing Project',     emoji: '✍️' },
  { value: 'film-production',        label: 'Film / Video Production',    emoji: '🎥' },
  { value: 'game-development',       label: 'Game Development',           emoji: '🎮' },
  { value: 'art-creative',           label: 'Art / Creative Project',     emoji: '🎨' },
  { value: 'pregnancy-parenting',    label: 'Pregnancy / Parenting',      emoji: '👶' },
  { value: 'health-wellness',        label: 'Health & Wellness Journey',  emoji: '🫀' },
  { value: 'relationship',           label: 'Relationship / Couples',     emoji: '💑' },
  { value: 'architecture-design',    label: 'Architecture / Design',      emoji: '🏛️' },
  { value: 'manufacturing',          label: 'Manufacturing / Supply Chain',emoji: '🏭' },
  { value: 'environmental',          label: 'Environmental / Climate',    emoji: '🌍' },
  { value: 'journalism',             label: 'News / Journalism',          emoji: '📰' },
  { value: 'volunteer-community',    label: 'Volunteer / Community',      emoji: '🤲' },
  { value: 'financial-journey',      label: 'Financial Journey',          emoji: '📈' },
  { value: 'culinary',               label: 'Culinary / Recipe Dev',      emoji: '🍳' },
  { value: 'space-mission',          label: 'Space Mission',              emoji: '🛸' },
  { value: 'pet-journey',            label: 'Pet / Animal Journey',       emoji: '🐾' },
  { value: 'home-renovation',        label: 'Home Renovation',            emoji: '🔨' },
  { value: 'photography-project',    label: 'Photography Project',        emoji: '📷' },
  { value: 'dance-performing-arts',  label: 'Dance / Performing Arts',    emoji: '💃' },
  { value: 'motorsport',             label: 'Motorsport / Racing',        emoji: '🏎️' },
  { value: 'mental-health',          label: 'Mental Health Journey',      emoji: '💚' },
  { value: 'podcast-media',          label: 'Podcast / Media Show',       emoji: '🎙️' },
  { value: 'language-learning',      label: 'Language Learning',          emoji: '🗣️' },
  { value: 'mythology-folklore',     label: 'Mythology / Folklore',       emoji: '🏺' },
  { value: 'nonprofit-campaign',     label: 'Nonprofit / Fundraising',    emoji: '🎗️' },
  { value: 'music-composition',      label: 'Music Composition / Production', emoji: '🎼' },
  { value: 'ocean-voyage',           label: 'Ocean / Marine Voyage',      emoji: '🌊' },
  { value: 'fashion',                label: 'Fashion / Style',            emoji: '👗' },
  { value: 'restaurant-hospitality', label: 'Restaurant / Hospitality',   emoji: '🍽️' },
  { value: 'recovery-rebuilding',    label: 'Recovery / Rebuilding',      emoji: '🏗️' },
  { value: 'memoir',                 label: 'Memoir / Personal Essay',    emoji: '📖' },
  { value: 'oral-history',           label: 'Oral History / Interviews',  emoji: '📼' },
  { value: 'war-history',            label: 'War / Conflict History',     emoji: '⚔️' },
  { value: 'civil-rights',           label: 'Civil Rights / Social Movement', emoji: '✊' },
  { value: 'philosophy',             label: 'Philosophy / Ideas',         emoji: '🧠' },
  { value: 'case-study',             label: 'Case Study / Analysis',      emoji: '🔎' },
  { value: 'diaspora',               label: 'Diaspora / Migration Story', emoji: '🌏' },
  { value: 'nature-writing',         label: 'Nature Writing / Field Notes', emoji: '🌿' },
  { value: 'science-history',        label: 'History of Science / Discovery', emoji: '⚗️' },
  { value: 'community-story',        label: 'Community / Neighborhood Story', emoji: '🏘️' },
];

export const TIMELINE_CATEGORY_GROUPS = [
  {
    label: 'Work & Business',
    values: ['project-management', 'company-history', 'product-roadmap', 'software-development', 'startup-journey', 'onboarding', 'marketing-campaign', 'manufacturing', 'construction', 'release-calendar', 'fiscal-year', 'legal-case'],
  },
  {
    label: 'Personal Life & Wellness',
    values: ['personal-biography', 'memoir', 'pregnancy-parenting', 'health-wellness', 'medical-history', 'mental-health', 'relationship', 'training-season', 'financial-journey', 'home-renovation', 'recovery-rebuilding', 'pet-journey'],
  },
  {
    label: 'History & Society',
    values: ['historical-events', 'war-history', 'civil-rights', 'political-campaign', 'military-campaign', 'immigration-journey', 'diaspora', 'community-story', 'crisis-management', 'mythology-folklore', 'family-genealogy'],
  },
  {
    label: 'Science, Research & Nature',
    values: ['scientific-research', 'investigative-research', 'case-study', 'archaeological-dig', 'environmental', 'space-mission', 'wildlife-migration', 'natural-disaster', 'nature-writing', 'science-history'],
  },
  {
    label: 'Arts & Creative',
    values: ['book-writing', 'art-creative', 'photography-project', 'dance-performing-arts', 'architecture-design', 'music-composition', 'game-development', 'fashion', 'oral-history'],
  },
  {
    label: 'Media & Entertainment',
    values: ['film-production', 'tv-season', 'podcast-media', 'music-tour', 'award-season', 'journalism'],
  },
  {
    label: 'Education & Ideas',
    values: ['education', 'academic-year', 'language-learning', 'philosophy', 'religious-calendar', 'annual-traditions'],
  },
  {
    label: 'Travel, Sports & Adventure',
    values: ['travel-trip', 'road-trip', 'expedition', 'ocean-voyage', 'motorsport', 'sports'],
  },
  {
    label: 'Food, Events & Community',
    values: ['culinary', 'restaurant-hospitality', 'event-planning', 'agricultural-cycle', 'volunteer-community', 'nonprofit-campaign'],
  },
];

// ─── MOBILE BREAKPOINTS ───────────────────────────────────────────────────────

export const MOBILE_EDITOR_BREAKPOINT = 768;

export const DEFAULT_COLORS = {
  primary:   '#FFB612',
  secondary: '#A8A9AD',
  tertiary:  '#0d0e0f',
};

export const COLOR_PRESETS = [
  // ── Developer Favorites ──────────────────────────────────────────────────────
  // Palettes sourced from well-known design systems and code editor themes.
  // All primaries verified ≥ 4.5:1 contrast against their tertiary (WCAG 2.1 AA).

  // Material Design — https://m2.material.io/design/color/the-color-system.html
  // Primary: Blue 800 (#1565C0) — Blue 700 (#1976D2) gives only 4.41:1; 800 gives 5.52:1 ✓
  { mode: 'light', name: 'Material Design',    primary: '#1565C0', secondary: '#388E3C', tertiary: '#FAFAFA' },

  // Tailwind CSS — https://tailwindcss.com/docs/customizing-colors
  // Primary: Indigo 700 (#4338CA) — Indigo 500 (#6366F1) gives only 4.29:1; 700 gives ~6.5:1 ✓
  { mode: 'light', name: 'Tailwind Default',   primary: '#4338CA', secondary: '#EC4899', tertiary: '#F9FAFB' },

  // Nord — https://www.nordtheme.com/docs/colors-and-palettes
  // Primary: Nord 8 (Frost), Secondary: Nord 9 (Frost), Tertiary: Nord 0 (Polar Night).
  // #88C0D0 on #2E3440 = 4.57:1 ✓
  { mode: 'dark',  name: 'Nord Arctic Blue',   primary: '#88C0D0', secondary: '#81A1C1', tertiary: '#2E3440' },

  // Solarized — https://ethanschoonover.com/solarized/
  // Primary adjusted: canonical Blue (#268BD2) gives ~3.4:1 on Base3; darkened to #1A6EA8 = 5.04:1 ✓
  { mode: 'light', name: 'Solarized',          primary: '#1A6EA8', secondary: '#2AA198', tertiary: '#FDF6E3' },

  // Dracula — https://draculatheme.com/contribute
  // Primary: Dracula Purple. #BD93F9 on #282A36 = ~6.6:1 ✓
  { mode: 'dark',  name: 'Dracula',            primary: '#BD93F9', secondary: '#FF79C6', tertiary: '#282A36' },

  // Monokai — as popularized by Sublime Text
  // Primary: Monokai Green. #A6E22E on #272822 = 9.58:1 ✓
  { mode: 'dark',  name: 'Monokai',            primary: '#A6E22E', secondary: '#F92672', tertiary: '#272822' },

  // Gruvbox — https://github.com/morhetz/gruvbox
  // Primary: Yellow-Green bright accent. #B8BB26 on #282828 = ~8.2:1 ✓
  { mode: 'dark',  name: 'Gruvbox',            primary: '#B8BB26', secondary: '#FE8019', tertiary: '#282828' },

  // ── Mood & Aesthetic ─────────────────────────────────────────────────────────

  // 1970s vintage sunset — warm orange on deep navy. #FF6B35 on #1A1A2E = 6.01:1 ✓
  { mode: 'dark',  name: 'Retro Sunset',       primary: '#FF6B35', secondary: '#F7C59F', tertiary: '#1A1A2E' },

  // Synthwave '84 — retro neon aesthetic. #FF7EDB on #262335 = 7.89:1 ✓
  { mode: 'dark',  name: "Synthwave '84",      primary: '#FF7EDB', secondary: '#36F9F6', tertiary: '#262335' },

  // Electric neon on near-black. #00FFFF on #0D0D0D = 16.1:1 ✓
  { mode: 'dark',  name: 'Neon Cyberpunk',     primary: '#00FFFF', secondary: '#FF00FF', tertiary: '#0D0D0D' },

  // Rose Pine — https://rosepinetheme.com. #EBBCBA on #191724 = 11.23:1 ✓
  { mode: 'dark',  name: 'Rose Pine',          primary: '#EBBCBA', secondary: '#C4A7E7', tertiary: '#191724' },

  // Catppuccin Mocha — https://github.com/catppuccin/catppuccin. #CBA6F7 on #1E1E2E = 9.01:1 ✓
  { mode: 'dark',  name: 'Catppuccin Mocha',   primary: '#CBA6F7', secondary: '#F38BA8', tertiary: '#1E1E2E' },

  // Bold tropical — vivid coral + green on deep dark. #FF4757 on #1A1A2E = 5.10:1 ✓
  { mode: 'dark',  name: 'Tropical Punch',     primary: '#FF4757', secondary: '#2ED573', tertiary: '#1A1A2E' },

  // Deep mulberry and dusty rose on warm cream. #6B2D5E on #FDF8F5 = 9.26:1 ✓
  { mode: 'light', name: 'Berry and Cream',    primary: '#6B2D5E', secondary: '#C06C84', tertiary: '#FDF8F5' },

  // ── Night Mode ───────────────────────────────────────────────────────────────

  // One Dark — as popularized by Atom and VS Code. #61AFEF on #282C34 = 7.41:1 ✓
  { mode: 'dark',  name: 'One Dark',           primary: '#61AFEF', secondary: '#E5C07B', tertiary: '#282C34' },

  // Tokyo Night — https://github.com/enkia/tokyo-night-vscode-theme. #7AA2F7 on #1A1B26 = 7.57:1 ✓
  { mode: 'dark',  name: 'Tokyo Night',        primary: '#7AA2F7', secondary: '#BB9AF7', tertiary: '#1A1B26' },

  // GitHub Dark — https://github.com/primer/primitives. #58A6FF on #0D1117 = 7.95:1 ✓
  { mode: 'dark',  name: 'GitHub Dark',        primary: '#58A6FF', secondary: '#3FB950', tertiary: '#0D1117' },

  // Night Owl — Sarah Drasner's VS Code theme. #7FDBCA on #011627 = 11.86:1 ✓
  { mode: 'dark',  name: 'Night Owl',          primary: '#7FDBCA', secondary: '#C792EA', tertiary: '#011627' },

  // Ayu Dark — https://github.com/ayu-theme/ayu-colors. #FF9940 on #0A0E14 = 9.59:1 ✓
  { mode: 'dark',  name: 'Ayu Dark',           primary: '#FF9940', secondary: '#39BAE6', tertiary: '#0A0E14' },

  // ── Mood & Aesthetic ─────────────────────────────────────────────────────────

  // Pantone Classic Blue (COTY 2020) + Living Coral (COTY 2019). #0F4C81 on #F5F5F0 = 8.10:1 ✓
  { mode: 'light', name: 'Pantone Classics',   primary: '#0F4C81', secondary: '#FF6F61', tertiary: '#F5F5F0' },
];
